// src/components/ChatPostList.js
/*
 * Legacy compatibility:
 * - Handles legacy message types (search_results/post) no longer emitted by Genkit.
 * - Retained only for backward compatibility with existing data.
 * - Remove after legacy data migration/cleanup is complete.
 */

import React from 'react';
import ChatPostItem from './ChatPostItem';
import { ChatPostSkeleton } from './ChatPostSkeleton';
import { usePostsSubscription } from '../hooks';
import './ChatPostList.css';

const ChatPostList = ({ postIds }) => {
  const { postsById } = usePostsSubscription(postIds);

  if (!Array.isArray(postIds) || postIds.length === 0) {
    return null;
  }

  return (
    <div className="chat-post-list">
      {postIds.map((id) => {
        const post = postsById[id];
        if (!post) {
          return <ChatPostSkeleton key={id} />;
        }
        return (
          <ChatPostItem 
            key={id} 
            post={post} 
          />
        );
      })}
    </div>
  );
};

export default ChatPostList;
